/* eslint-disable */
import "../../asset/css/contact.css";
import { useState, useRef } from "react";
import { motion } from "framer-motion";
import contact_bg_logo from "../../asset/images/contact_gong_only_logo.png";

import mail_icon from "../../asset/images/mail_icon.png";
import marker_icon from "../../asset/images/marker_icon.png";
import phone_icon from "../../asset/images/phone_icon.png";
import emailjs from "@emailjs/browser";
import { useMediaQuery } from "react-responsive";

export default function ContactSection() {
  const isResponsive = useMediaQuery({
    query: "(max-width : 1400px)",
  });
  const cs_info_list = [
    { img: mail_icon, title: "E-mail", desc: "contact@gongsaero.com" },
    { img: phone_icon, title: "Phone", desc: "+82) 70-8098-8224" },
    {
      img: marker_icon,
      title: "Address",
      desc: "508, Insta1, Convensia-daero 204, Yeonsu-gu, Incheon, Republic of Korea",
    },
  ];

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm("service_itayvyv", "template_9ke1wy6", form.current, "zHCljDADvP6xTuvpa").then(
      (result) => {
        alert("Success Send Email!");
        form.current.reset();
      },
      (error) => {
        console.log(error.text);
        alert("이메일이 전송이 실패되었습니다.");
      },
    );
  };

  return (
    <div className="contact_section_container">
      <div className="cs_main">
        <motion.div className="cs_desc_container" initial={{ x: -100 }} whileInView={{ x: 0 }}>
          <div className="cs_title">Contact</div>
          {cs_info_list.map((item, idx) => {
            return (
              <div className="cs_descs">
                <img src={item.img} className="cs_desc_img" />
                <div className="cs_desc_elem">
                  <span>{item.title}</span>
                  <span>
                    {item.desc.split("204, ").map((line, index) => (
                      <p>{line}</p>
                    ))}
                  </span>
                </div>
              </div>
            );
          })}
        </motion.div>
        <form className="cs_input_container" ref={form} onSubmit={sendEmail}>
          <div className="cs_input1">
            <div className="cs_input_box">
              <span>Name*</span>
              <motion.input whileFocus={{ scale: 1.05 }} name="name" required autoComplete="none" />
            </div>
          </div>
          <div className="cs_input2">
            <div className="cs_input_box">
              <span>Company*</span>
              <motion.input whileFocus={{ scale: 1.05 }} name="company" required autoComplete="none" />
            </div>
            <div className="cs_input_box">
              <span>Department</span>
              <motion.input whileFocus={{ scale: 1.05 }} name="department" autoComplete="none" />
            </div>
          </div>
          <div className="cs_input2">
            <div className="cs_input_box">
              <span>Business E-mail*</span>
              <motion.input whileFocus={{ scale: 1.05 }} type="email" name="email" required autoComplete="none" />
            </div>
            <div className="cs_input_box">
              <span>Phone number</span>
              <motion.input whileFocus={{ scale: 1.05 }} name="phone" autoComplete="none" />
            </div>
          </div>
          <div className="cs_input4">
            <div className="cs_input_box">
              <span>Message</span>
              <motion.textarea rows="10" whileFocus={{ scale: 1.05 }} name="memo" autoComplete="none" />
            </div>
          </div>
          <div className="cs_submit">
            <motion.button
              type="submit"
              className="cs_submit_btn"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              Send Email
            </motion.button>
          </div>
        </form>
      </div>
      <motion.img src={contact_bg_logo} className="cs_bg_logo" />
    </div>
  );
}
